export default "__VITE_ASSET__B9W3$7JM__"